//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : Start
import { useState, useMemo, useCallback, useRef, memo, useEffect } from "react";
import { BzButton, BzDotsLoader, BzInputText, BzMasterAgGrid, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { handleModal, handleModalData } from "../../redux/actions/modals";


import { GRID_ROW_SELECTION_TYPE, ORDER_PRODUCT_TYPES, TL_INDEX, TRADING_NOT_ALLOWED_MSG_BASKET } from "../../utils/global_variables";
import { RECOMMENDATION_CART_GRID_REF, convertNumberWithCommasForCurrency, deepClone, getGridAllRows, setRecommendationCartGridRef } from "../../utils/global_functions";
import { getWfhTouchlineLastTick } from "../../redux/actions/wfh";
import { sendTouchlineRequest } from "../../apis/web_socket";
import { getOrderMarginInfo, orderMarginInfoSuccess } from "../../redux/actions/orders";
import { useDebounce, useWFHMessages } from "../../hooks";
import CustomiseCartAlertModal from "./CustomiseCartAlertModal";
import { updateBasketReco, updateCartCount } from "../../redux/actions/recommendation";
import { updateOrdercartMargin } from "../../redux/actions/orderCart";
import BasketRecoHoldingAlertModal from "./BasketRecoHoldingAlertModal";
import { toastConfig } from "../../redux/actions/toast";
import { _checkSegmetAllowed } from "../../controllers";


const RecommendationCartModal = () => {
    setRecommendationCartGridRef(useRef());
    const modals = useSelector(state => state.modals.modals);
    const dispatch = useDispatch();
    const modalData = useSelector(state => state.modals.modalData);
    const objBasketRecommendation = useSelector(state => state.recommendation?.objBasketReco);
    const nPrevCartCount = useSelector(state => state?.recommendation?.prevCartCount);
    const [nCartCount, setNCartCount] = useState(nPrevCartCount ?? 1);
    const strOrderCartIdentifier = modalData?.data?.cartData?.sRecoId;
    const isLoadingMarginInfo = useSelector(state => state.orders.isLoadingMarginInfo);
    const arrMarginInfo = useSelector(state => state.orders.arrMarginInfo);
    const arrGridData = useSelector(state => state.recommendation.arrBasketReco);
    const holdingsScrips = useSelector(state => state?.holdings?.holdingsScrips);
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    const [inputValue, setInputValue] = useState('1');
    const MININPUTVALUE = 1;
    const MAXINPUTVALUE = 999;
    const handleClose = () => {
        dispatch(handleModal([{ ['RECOMMENDATION_CART_MODAL']: false }]));
        dispatch(updateBasketReco([]));
    };
    useEffect(() => {
        if (modalData?.data?.isGoback) {
            setInputValue(nPrevCartCount);
        }
    }, [modalData]);
    const arrRowData = useMemo(() => {
        if (arrGridData?.length > 0) {
            return arrGridData.map(eachRow => ({
                ...eachRow, QTY: eachRow["QTY"] * nCartCount
            }));
        }
    }, [arrGridData, nCartCount]);
    const SymbolComponent = (props) => {
        return (
            <>
                {
                    <div className='d-flex align-items-center justify-content-start pt-2'>
                        <div className='d-flex flex-column justify-content-start'>
                            <div className='d-flex align-items-center range-container my-2'>
                                <div className='font-medium font-size2 color-text text-uppercase me-2'>{props?.data?.SYMBOL}</div>
                                <span className='font-regular font-size2 color-subtext text-uppercase'>{props?.data?.SERIES}</span>
                            </div>
                            <div className='d-flex align-items-center range-container'>
                                <div className='font-regular font-size1 color-text pe-2'>{props?.data?.LTP ? props?.data?.LTP : '0.00'}</div>
                                <div className={`font-regular font-size1 color-text ${Number(props?.data?.CLTP) >= 0 ? 'color-positive' : 'color-negative'}`}>{props?.data?.CLTP ? props?.data?.CLTP : '0.00'} ({props?.data?.LTPPERCENT ? props?.data?.LTPPERCENT : '0.00'}%)</div>
                            </div>
                        </div>

                    </div>
                }
            </>
        );
    };

    const columnDefs = useMemo(() => {
        return [
            {
                field: "BUY/SELL", suppressMovable: true,
                suppressNavigable: true, maxWidth: 80, resizable: false, sortable: false, menuTabs: [], cellStyle: params => ({ color: params.value === 'BUY' ? 'green' : 'red' })
            },
            {
                field: "SYMBOL", suppressMovable: true, cellRenderer: SymbolComponent,
                suppressNavigable: true, minWidth: 80, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "EXCHANGE", suppressMovable: true,
                suppressNavigable: true, maxWidth: 90, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "PROD TYPE", suppressMovable: true,
                suppressNavigable: true, minWidth: 50, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "ORDER TYPE", suppressMovable: true,
                suppressNavigable: true, minWidth: 50, maxWidth: 100, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "QTY", suppressMovable: true,
                suppressNavigable: true, minWidth: 80, resizable: false, sortable: false, menuTabs: []
            },
            {
                field: "PRICE", suppressMovable: true,
                suppressNavigable: true, maxWidth: 100, resizable: false, sortable: false, menuTabs: []
            },

            {
                field: "VALIDITY", suppressMovable: true,
                suppressNavigable: true, maxWidth: 100, resizable: false, sortable: false, menuTabs: []
            },
        ];
    }, []);
    const calculatedAndGetOrderMarginInfoFor = useCallback((arrOrderInfo) => {
        let nTotalMargin = 0;
        let nTotalAvailableMargin = 0;

        dispatch(orderMarginInfoSuccess({}));
        let devidedArray = divideArrayIntoGroups(arrOrderInfo, 10);
        devidedArray?.forEach(async (eachGroupArray) => {
            let arrFilterData = eachGroupArray?.filter(eachData => eachData["BUY/SELL"] === 'BUY');
            const arrLegDetails = arrFilterData?.map((eachScrip, i) => {
                return {
                    "LegNo": i + 1,
                    "BuyOrSell": 1,
                    "MarketSegmentId": eachScrip["EXCHANGEID"],
                    "Token": eachScrip["TOKEN"],
                    "Quantity": eachScrip["QTY"],
                    "Price": Math.round(eachScrip["PRICE"] * eachScrip["DECIMALLOCATOR"]),
                    "MktFlag": eachScrip["ORDER TYPE"].includes('MKT') ? 1 : 0,
                    "OldPrice": 0,
                    "OldQuantity": 0,
                    "ProductType": eachScrip["PROD TYPE"].includes(ORDER_PRODUCT_TYPES.DELIVERY) ? "D" : "M",
                    "LegIndicator": 0
                };
            });
            let objResp = await dispatch(getOrderMarginInfo(arrLegDetails));
            let nApproxMargin = objResp?.data?.data?.result?.ApproxMargin;
            let nAvailableMargin = objResp?.data?.data?.result?.AvailableMargin;
            nTotalMargin = (parseFloat(nTotalMargin) + parseFloat(nApproxMargin)).toFixed(2);
            nTotalAvailableMargin = (parseFloat(nTotalAvailableMargin) + parseFloat(nAvailableMargin)).toFixed(2);
            let objMarginResult = deepClone(objResp?.data?.data?.result);
            objMarginResult.ApproxMargin = nTotalMargin;
            objMarginResult.AvailableMargin = nTotalAvailableMargin;
            dispatch(updateOrdercartMargin(nTotalMargin));
            dispatch(orderMarginInfoSuccess(objMarginResult));
        });
    }, [dispatch]);
    useEffect(() => {
        if (arrRowData?.length > 0) {
            calculatedAndGetOrderMarginInfoFor(arrRowData);
        }
    }, [arrRowData, calculatedAndGetOrderMarginInfoFor]);

    const handlePlaceOrder = () => {
        let arrOrderData = [];
        let arrGridData = [...arrRowData];
        let bIsValidationFailed = false;
        let arrHoldingMessage = [];
        let bIsExchangeNotAllowed = false;
        let arrExchangesNotAllowed = [];

        arrGridData?.forEach(eachScrip => {
            if (!(_checkSegmetAllowed(`${eachScrip["EXCHANGE"]}_${eachScrip["SERIES"]}`?.toUpperCase(), objLoginSession?.data?.exchanges))) {
                bIsExchangeNotAllowed = true;
                if (arrExchangesNotAllowed?.length === 0) {
                    arrExchangesNotAllowed.push(eachScrip["EXCHANGE"]);
                }
                else {
                    if (!(_checkSegmetAllowed(eachScrip["EXCHANGE"]), arrExchangesNotAllowed)) {
                        arrExchangesNotAllowed.push(eachScrip["EXCHANGE"]);
                    }
                }
            }
        });
        if (bIsExchangeNotAllowed) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: `${TRADING_NOT_ALLOWED_MSG_BASKET} ${arrExchangesNotAllowed.join(', ')}` }));
            return;
        }
        else {
            arrGridData.forEach(eachScrip => {
                if (eachScrip["PROD TYPE"].toUpperCase().includes(ORDER_PRODUCT_TYPES.DELIVERY) && eachScrip["BUY/SELL"] == "SELL") {
                    const objHoldingScrip = holdingsScrips?.find(each => each.nPreferredMTMToken == eachScrip["TOKEN"]);
                    if (objHoldingScrip && Object.keys(objHoldingScrip).length > 0) {
                        if (eachScrip["QTY"] > parseInt(objHoldingScrip.TOTALFREEQUANTITY)) {
                            bIsValidationFailed = true;
                            eachScrip["bIsDelete"] = true;
                            arrHoldingMessage.push(`${eachScrip["SYMBOL"]}`);
                        }
                    }
                    else {
                        bIsValidationFailed = true;
                        eachScrip["bIsDelete"] = true;
                        arrHoldingMessage.push(`${eachScrip["SYMBOL"]}`);
                    }
                }
            });
            arrGridData?.forEach((ele, i) => {
                if (!Object.keys(ele).includes('bIsDelete')) {
                    let objData = {
                        id: i + 1,
                        buySellType: ele["BUY/SELL"],
                        productType: ele["PROD TYPE"].toUpperCase(),
                        orderType: ele["ORDER TYPE"],
                        validity: ele["VALIDITY"],
                        exchange: ele['EXCHANGE'],
                        count: ele["QTY"],
                        amo: false,
                        slTrigger: '0.00',
                        slLimit: "0.00",
                        price: ele["PRICE"],
                        exchangeId: ele["EXCHANGEID"],
                        token: ele["TOKEN"],
                        decimalLocator: ele["DECIMALLOCATOR"],
                        symbol: ele["SYMBOL"],
                        series: ele["SERIES"],
                        instrument: ele["INSTRUMENT"],
                        exchangeSegment: `${ele["EXCHANGE"]}_${ele["SERIES"]}`,
                        isinCode: ele["ISINCODE"],
                        securityDesc: ele["SECURITYDESC"],
                        expiryDate: 'NA',
                        strikePrice: 'NA',
                        optionType: 'NA',
                        priceTick: ele["PRICETICK"] * ele["DECIMALLOCATOR"],
                        mappedSegId: ele["MAPPEDMKTSEGID"],
                        marketLot: ele["MARKETLOT"],
                        maturityDate: 'NA',
                        expiryInMilliSec: 'NA'
                    };
                    arrOrderData.push(objData);
                }
            });
            let modalData = {
                data: {
                    orderCartInfo: arrOrderData,
                }
            };
            if (!bIsValidationFailed) {

                dispatch(updateCartCount(nCartCount));
                dispatch(handleModal([{ 'ORDER_ENTRY_CONFIRMATION': true }, { 'RECOMMENDATION_CART_MODAL': false }, true]));
                dispatch(handleModalData({ data: { orderCartConfirmation: modalData, orderEntryTab: 'multi_scrip', activeTabKey: 'basket', orderCartId: objBasketRecommendation?.ordercartId, orderCartName: objBasketRecommendation?.ordercartName, orderIdentifier: strOrderCartIdentifier, orderFrom: 'BASKETRECO' } }));
            }
            else {
                dispatch(handleModal([{ ['BASKET_RECO_HOLDING_ALERT_MODAL']: true }]));
                dispatch(handleModalData({ data: { orderCartConfirmation: modalData, orderEntryTab: 'multi_scrip', activeTabKey: 'basket', orderCartId: objBasketRecommendation?.ordercartId, orderCartName: objBasketRecommendation?.ordercartName, orderIdentifier: modalData?.data?.cartData?.sRecoId, orderFrom: 'BASKETRECO', scripInfo: arrHoldingMessage.join(',') } }));

            }
        }
    };
    const handleIncDec = (name, value) => {
        switch (name) {
            case "subQuantity":
                if ((Number(value)) && value >= MININPUTVALUE && value <= MAXINPUTVALUE) {
                    setInputValue(value);
                }
                break;
            case "addQuantity":
                if ((Number(value)) && value >= MININPUTVALUE && value <= MAXINPUTVALUE) {
                    setInputValue(value);
                }
                break;
            default:
        }
    };
    const getRowId = useCallback((params) => {

        if (params?.data) {
            return params?.data?.id;
        } else {
        }
    }, []);
    // BREEZE-8190 : Basket Order  Recommendation : ManasaB : 08-09-2025 : SAT 2 issue - Start 
    const handleQuantity = (e) => {
        const value = e.target.value;
        let nValue = parseInt(value, 10);
        if (nValue && !isNaN(nValue) && nValue <= MAXINPUTVALUE && nValue >= MININPUTVALUE) {
            setInputValue(nValue);
        }
        else {
            if (value === '') {
                setInputValue("");
                return;
            }
        };
    }
        const handleBlur = (e) => {
            let value = e.target.value;
            if (value === '') {
                setInputValue(1);
            }
        };
        // BREEZE-8190 : Basket Order  Recommendation : ManasaB : 08-09-2025 : SAT 2 issue - End
        useDebounce(() => {
            const parsedInputValue = parseInt(inputValue, 10);
            if (!isNaN(parsedInputValue) && parsedInputValue >= MININPUTVALUE && parsedInputValue <= MAXINPUTVALUE) {
                setNCartCount(parsedInputValue);
            }
        }, 300, [inputValue]);

        const selectionColumnDef = useMemo(() => {
            return {
                pinned: 'left',
                hide: true,
            };
        }, []);
        const rowSelection = useMemo(() => {
            return {
                mode: GRID_ROW_SELECTION_TYPE.SINGLE_ROW,
                checkboxes: true
            };
        }, []);
        function divideArrayIntoGroups(array, groupSize) {
            let dividedArrays = [];
            let currentIndex = 0;

            while (currentIndex < array?.length) {
                let curentGroup = array?.slice(currentIndex, currentIndex + groupSize);
                dividedArrays?.push(curentGroup);
                currentIndex += groupSize;
            }
            return dividedArrays;
        }






        const handleCustomizeCart = () => {
            const arrUpdatedData = [...arrRowData];
            dispatch(updateBasketReco(arrUpdatedData));
            dispatch(handleModal([{ 'CUSTOMISE_CART_ALERT_MODAL': true }]));
        };



        const handleLiveData = useCallback((arrLiveData) => {
            let data = arrRowData?.find((eachRow) => eachRow?.id === arrLiveData[TL_INDEX.SEGMENT_ID] + '_' + arrLiveData[TL_INDEX.TOKEN]);
            if (data) {
                let newData = { ...data, LTP: arrLiveData[TL_INDEX.LAST_TRADE_PRICE], CLTP: arrLiveData[TL_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE], LTPPERCENT: arrLiveData[TL_INDEX.NET_CHANGE_FROM_PRE_CLOSE] };
                RECOMMENDATION_CART_GRID_REF?.current?.api?.applyTransaction({
                    update: [newData]
                });
                RECOMMENDATION_CART_GRID_REF?.current?.api.refreshCells({ force: true });
            }
        }, [arrRowData]);

        useWFHMessages('touchline', (e) => {
            handleLiveData([...e.detail]);
        });



        const onFirstDataRendered = useCallback(() => {
            const arrScripsForSubscription = [];
            let arrData = getGridAllRows(RECOMMENDATION_CART_GRID_REF?.current?.api)?.map(node => {
                arrScripsForSubscription.push({ exchangeId: node.data.EXCHANGEID, token: node.data.TOKEN, isSubscribe: true });
                return node?.data;
            });
            sendTouchlineRequest(arrScripsForSubscription);
            setTimeout(() => {
                const objLastTickData = dispatch(getWfhTouchlineLastTick());
                arrData.forEach(data => {
                    let arrLast = objLastTickData[`${data.EXCHANGEID}_${data.TOKEN}`];
                    if (arrLast?.length > 0) {
                        handleLiveData(arrLast);
                    }
                });
            }, 500);

        }, [dispatch, handleLiveData]);


        return (
            <>
                <BzModal size='lg' show={modals['RECOMMENDATION_CART_MODAL']} onHide={handleClose}>
                    <BzModalHeader className='modaltabs-header'>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col md={11} className='d-flex justify-content-start align-items-center col'>
                                    <div className='icon-16 icon-cart icon-dark me-2'></div>
                                    <div className='font-medium font-size4 color-text'>{objBasketRecommendation?.ordercartName?.toUpperCase()}</div>
                                </Col>
                                <Col md={1} className='d-flex justify-content-end align-items-center col'>
                                    <div data-testid={"modal-close"} className='icon-16 icon-dark icon-close' onClick={handleClose}></div>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalHeader>
                    <BzModalBody>
                        <Container fluid className='p-0'>
                            <Row className='g-0 align-items-center mb-3'>
                                <Col md={4}>
                                    <div className="d-flex align-items-center">
                                        <div className='font-medium font-size1 color-text text-nowrap me-2'>No of cart(s):</div>
                                        <div className='input-group position-relative'>
                                            <div className='icon-12 icon-order-decrease input-number-left-wrap' onClick={handleIncDec.bind(this, "subQuantity", (parseInt(inputValue)) - 1)}> </div>
                                            {<BzInputText size='sm' type='number' className='font-regular text-center form-control' name="count" onChange={handleQuantity.bind(this)} onBlur={handleBlur} value={inputValue} min={1} max={999} onKeyDown={(e) => (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-' || e.key === '.') && e.preventDefault()} />}
                                            <div className='icon-12 icon-order-increase input-number-right-wrap' onClick={() => handleIncDec("addQuantity", (parseInt(inputValue)) + 1)} ></div></div>
                                    </div>
                                </Col>
                                <Col md={4}>&nbsp;</Col>
                                <Col md={4} className='d-flex justify-content-end align-items-center'>
                                    <BzButton className='btn btn-md btn-outline text-capitalize' onClick={handleCustomizeCart}>Customize Cart</BzButton>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <BzMasterAgGrid
                                    gridKey={'Basket'}
                                    selectionColumnDef={selectionColumnDef}
                                    rowSelection={rowSelection}
                                    rowHeight={70}
                                    isFirstDataRendered={onFirstDataRendered}
                                    className='ag-theme-alpine multiscrip-ordercart-ag-grid-wrapper'
                                    ref={RECOMMENDATION_CART_GRID_REF}
                                    getRowId={getRowId}
                                    arrRowData={arrRowData}
                                    rowBuffer={1}
                                    arrColumnData={columnDefs}
                                    isShowEmptyGrid={true}
                                />
                            </Row>
                        </Container>
                    </BzModalBody>
                    <BzModalFooter>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col md={6} className='d-flex justify-content-start align-items-center'>
                                    <div className='d-flex flex-column justify-content-start pe-4'>
                                        <div className='font-regular font-size1 color-text'>Approx. Margin</div>
                                        {
                                            isLoadingMarginInfo ?
                                                <BzDotsLoader />
                                                :
                                                arrRowData?.length > 0 && <div className='font-medium font-size1 color-text'>{parseFloat(arrMarginInfo?.ApproxMargin) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.ApproxMargin), true) : arrMarginInfo?.ApproxMargin}</div>
                                        }
                                    </div>
                                    <div className='d-flex flex-column justify-content-start pe-4'>
                                        <div className='font-regular font-size1 color-text'>Available Margin</div>
                                        {

                                            isLoadingMarginInfo ?
                                                <BzDotsLoader />
                                                :
                                                arrRowData?.length > 0 && <div className='font-medium font-size1 color-text'>{!isNaN(parseFloat(arrMarginInfo?.AvailableMargin)) ? convertNumberWithCommasForCurrency(parseFloat(arrMarginInfo?.AvailableMargin), true) : arrMarginInfo?.AvailableMargin}</div>
                                        }
                                    </div>
                                    <div className='d-flex align-items-center pe-4 cursor-pointer focus' >
                                        <div className='icon-12 icon-refresh background-textual-link-withicon'></div>
                                        <div className='font-medium font-size1 color-textual-link-withicon ms-2' onClick={() => calculatedAndGetOrderMarginInfoFor([...arrRowData])}>Update</div>
                                    </div>
                                </Col>
                                <Col md={6} className='d-flex justify-content-end align-items-center'>
                                    <BzButton className='btn btn-md btn-primary text-capitalize' onClick={handlePlaceOrder}> PLACE ORDER</BzButton>
                                </Col>
                            </Row>
                        </Container>
                    </BzModalFooter>
                </BzModal>
                {modals['CUSTOMISE_CART_ALERT_MODAL'] && <CustomiseCartAlertModal />}
                {modals['BASKET_RECO_HOLDING_ALERT_MODAL'] && <BasketRecoHoldingAlertModal />}
            </>
        );
    };

    export default memo(RecommendationCartModal);
//BREEZE-8190 : Basket Order Recommendation : ManasaB : 26-08-2025 : End

